import { GreenBold } from 'components/Tables/ActivityTableV2/CellEvent/CellEventFormatter'

export const DefaultAddOrRemoveEvent = ({
  action,
  fieldName,
  values,
}: {
  action: string
  fieldName: string
  values: string | React.ReactNode
}) => {
  // Plain text values (campaigns, distributors, GPOs joined names) get the
  // bold emphasis; React nodes (e.g. pill arrays from the tag variants) are
  // already styled and shouldn't be wrapped in <b>.
  const rendered = typeof values === 'string' ? <b>{values}</b> : values
  // "added new tags" reads naturally; "removed new tags" doesn't —
  // the tags being removed aren't new, so drop the qualifier when
  // the action is a removal.
  const qualifier = action === 'added' ? 'new ' : ''
  return (
    <>
      {action} {qualifier}
      <GreenBold>{fieldName}</GreenBold>: {rendered}
    </>
  )
}
